const MeiliLinesColumns = [
    { headerName: 'Charge Type', field: 'chargeType' },
    { headerName: 'Brand', field: 'brand' },
    { headerName: 'Location Mnemonic', field: 'loc' },
    { headerName: 'Customer No.', field: 'custNo' },
    { headerName: 'Description', field: 'desc' },
    { headerName: 'RA Number', field: 'raNo' },
    { headerName: 'Charge Code', field: 'chCode' },
    { headerName: 'Country', field: 'countryCode' },
    { headerName: 'Reservation No.', field: 'resNo' },
    { headerName: 'Charge Period', field: 'chargePeriod' },
    { headerName: 'Checkout Date', field: 'coDate' },
    { headerName: 'Checkin Date', field: 'ciDate' },
    { headerName: 'Renter Name', field: 'renterName' },
    { headerName: 'Product Name', field: 'prodName' },
    { headerName: 'Territory Description', field: 'territory' },
    { headerName: 'Voucher', field: 'voucher' },
    { headerName: 'Discount', field: 'discount' },
    { headerName: 'Amount', field: 'amount' },
    { headerName: 'Batch Ref. No.', field: 'batchRef' },
    { headerName: 'CL Indicator', field: 'clInd' },
    { headerName: 'Station Indicator', field: 'stInd' }
];

export default MeiliLinesColumns;
  